var exports = {
  "kL": "MobileBottomNavSkeleton.module__container___SEp2OE",
  "pc": "MobileBottomNavSkeleton.module__navItem___SEp2OE",
  "hk": "MobileBottomNavSkeleton.module__navItemLabel___SEp2OE",
};

module.exports = exports;
